import type { NavigationGroup, NavigationMatch } from '../../types'

export function findNavigationMatch(
  groups: readonly NavigationGroup[],
  pathname: string
): NavigationMatch | null {
  const matches = groups.flatMap((group) =>
    group.items
      .filter(
        (item) => pathname === item.to || pathname.startsWith(`${item.to}/`)
      )
      .map((item) => ({ group, item }))
  )
  return matches[0] ?? null
}
